/* globals process, location */

import { STORE_CODE_LOCALE } from '!/common/constants';
import locale, { storeSpecificTranslations } from '!/common/locale';

/* globals Vitafy */

/**
 * @function addGAEventTracking
 *
 * @param {String} eventType
 * @param {String} eventCategory
 * @param {String} eventLabel
 *
 * @returns {Object}
 */
export function addGAEventTracking(eventType, eventCategory, eventLabel) {
  return {
    'data-ga-action': eventType,
    'data-ga-cat': eventCategory,
    'data-ga-label': eventLabel
  };
}

export function sendGAEvent(category, action, label) {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: "ga-event",
      'event-action': action,
      'event-cat': category,
      'event-label': label
    });
  }
}

/**
 * @param {number} hitsPerPage
 * @param {numer} currentPage
 */

export function createGAListObject(hitsPerPage, currentPage, appliedFilters) {
  const startIndex = currentPage === 1 ? 0 : (currentPage - 1) * hitsPerPage;
  const filters = Object.keys(appliedFilters).length === 0 ? '' : ` Filters: ${JSON.stringify(appliedFilters)}`;

  if (vitafyObjItemAvailable('ImpressionsGA')) {
    new Vitafy.ImpressionsGA(startIndex, location.pathname.replace('/', '') + filters);
  }
}

/**
 * @function vitafyObjItemAvailable
 *
 * @param {String} keyName
 *
 * @returns {Boolean}
 */
export function vitafyObjItemAvailable(keyName) {
  return typeof Vitafy !== 'undefined' && typeof Vitafy[keyName] !== 'undefined';
}

/**
 * Returns a localized string depending on the store code
 *
 * @param {String} str
 * @param {String|Number} val
 *
 * @returns {String}
 */
export function getLocale(str, val) {
  let storeCode = 'de_de';
  if (vitafyObjItemAvailable('storeCode')) {
    storeCode = Vitafy.storeCode;
  }
  else if (process.env.STORE_CODE) {
    storeCode = process.env.STORE_CODE;
  }

  // check if storeCode is mapped to country code
  const countryCode = STORE_CODE_LOCALE[storeCode] || 'de_DE';
  // if there's no translation, simply return the argument
  const translation = (storeSpecificTranslations[storeCode]?.[str] || locale[countryCode]?.[str] || str);
  // replace placeholder, if available
  return translation.replace('%s', val);
}

export const convertValueToIntegers = value => {
  return value
    .split('-')
    .map(item => Math.abs(item))
    .filter(item => !isNaN(item));
};



